// removed by extract-text-webpack-plugin
module.exports = {"title":"title__25895","edit":"edit__GHAx9","form-control":"form-control__doGWy","label-name":"label-name__6vvH6","entity-value":"entity-value__1WYRL"};


//////////////////
// WEBPACK FOOTER
// ./styles/invest/userEntity.scss
// module id = 1199
// module chunks = 68